export const blackListTypes = {
    own_list: 'OWN',
    related_pep: 'RELATED',
    external_pep: 'EXTERNAL',
    local_pep: 'LOCAL',
    negative_news: 'NEGATIVE',
    requested: 'REQUESTED'
  };